import { forwardRef, type Ref, type SVGProps } from "react";
const IconCameraShutterOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m-3.81 13.74 1.7-2.74h3.64l1.62 2.92L17.23 19H14Zm13.57-6.69A11.86 11.86 0 0 1 28 16a12.3 12.3 0 0 1-.39 3h-8Zm-1.36-1.6-4 6.52-5.54-9.91A11 11 0 0 1 16 4a12 12 0 0 1 8.4 3.45m-11.61-3L16.42 11H5.11a12 12 0 0 1 7.68-6.55M4.39 13h7.15l-5.75 9.27A11.9 11.9 0 0 1 4 16a12.3 12.3 0 0 1 .39-3m2.69 11 3.9-6.3 5.7 10.3H16a11.9 11.9 0 0 1-8.92-4m11.71 3.67L15.1 21h11.79a12 12 0 0 1-8.1 6.66Z" />
  </svg>
);
const ForwardRef = forwardRef(IconCameraShutterOutlineSVG);
ForwardRef.displayName = "IconCameraShutterOutline";
export { ForwardRef as IconCameraShutterOutline };
